import React, { Component } from 'react';

import './styles.less';

export default class CircularLoadingSpinner extends Component {
  state = {
    render: false,
  };

  static defaultProps = {
    color: 'white',
    delay: 0,
  };

  render() {
    return this.state.render ? (
      <div className="circular-loading-spinner">
        <svg viewBox="0 0 41 41">
          <defs>
            <path
              id="a"
              d="M20.5 2.816c-9.751 0-17.684 7.933-17.684 17.684 0 9.75 7.933 17.684 17.684 17.684 9.75 0 17.685-7.933 17.685-17.684 0-9.751-7.934-17.684-17.685-17.684m0 36.868c-10.578 0-19.184-8.606-19.184-19.184C1.316 9.922 9.922 1.316 20.5 1.316c10.578 0 19.185 8.606 19.185 19.184 0 10.578-8.607 19.184-19.185 19.184"
            />
            <path
              id="c"
              d="M7.465 9.465a2 2 0 0 1-1.414-3.414A20.295 20.295 0 0 1 20.5.066c5.459 0 10.59 2.125 14.45 5.985A2 2 0 1 1 32.12 8.88 16.326 16.326 0 0 0 20.5 4.066 16.326 16.326 0 0 0 8.88 8.88a1.992 1.992 0 0 1-1.415.586"
            />
          </defs>
          <g fill="none" fillRule="evenodd">
            <path
              fill="none"
              d="M41 20.5C41 31.822 31.822 41 20.5 41 9.179 41 0 31.822 0 20.5S9.179 0 20.5 0C31.822 0 41 9.178 41 20.5"
            />
            <mask id="b" fill="currentColor">
              <use xlinkHref="#a" />
            </mask>
            <use fill="currentColor" xlinkHref="#a" />
            <g fill="currentColor" mask="url(#b)">
              <path d="M1 0h40v40H1z" />
            </g>
            <mask id="d" fill="currentColor">
              <use xlinkHref="#c" />
            </mask>
            <use fill="currentColor" xlinkHref="#c" />
            <g fill="currentColor" mask="url(#d)">
              <path d="M1 0h40v40H1z" />
            </g>
          </g>
        </svg>
      </div>
    ) : null;
  }

  componentDidMount() {
    this.initialTimeout = setTimeout(
      () => this.setState({ render: true }),
      this.props.delay
    );
  }

  componentWillUnmount() {
    clearTimeout(this.initialTimeout);
  }
}
